import { Box, Divider, Typography } from '@mui/material'

const EducationCard = ({
  qualification,
  course = 'Quantum Mechanics',
  startYear = '1948',
  endYear = '2022',
  university = 'University of Menara Gading',
  country,
  cgpa,
  academicField,
}) => {
  return (
    <Box paddingX={2}>
      <Typography
        variant="h4"
        color="dark-text.main"
        paddingY={1}
        align="left"
        marginBottom={2}
        sx={{
          fontWeight: 'bold',
        }}
      >
        {course === 'Not Applicable' || course === 'Others'
          ? qualification
          : `${qualification} in ${course}`}
      </Typography>
      {/* hide for now */}
      {/* <Box display="flex" gap={9}>
        <Typography
          width={80}
          variant="body1"
          color="light-gray-text.main"
          align="left"
          marginBottom={2}
        >
          Field
        </Typography>
        <Typography
          display="flex"
          alignItems="center"
          variant="body1"
          color="light-gray-text.main"
          align="left"
          marginBottom={2}
        >
          {academicField}
        </Typography>
      </Box> */}
      {startYear && (
        <Box display="flex" gap={9}>
          <Typography
            width={80}
            variant="body1"
            color="light-gray-text.main"
            align="left"
            marginBottom={2}
          >
            Tenure
          </Typography>
          <Typography
            display="flex"
            alignItems="center"
            variant="body1"
            color="light-gray-text.main"
            align="left"
            marginBottom={2}
          >
            {startYear}-{endYear}
          </Typography>
        </Box>
      )}
      <Box display="flex" gap={9}>
        <Typography
          width={80}
          variant="body1"
          color="light-gray-text.main"
          align="left"
          marginBottom={2}
        >
          CGPA
        </Typography>
        <Typography
          display="flex"
          alignItems="center"
          variant="body1"
          color="light-gray-text.main"
          align="left"
          marginBottom={2}
        >
          {cgpa}
        </Typography>
      </Box>
      <Box display="flex" gap={9}>
        <Typography
          width={80}
          variant="body1"
          color="light-gray-text.main"
          align="left"
          marginBottom={2}
        >
          University
        </Typography>
        <Typography variant="body1" color="dark-text.main" align="left" marginBottom={2}>
          {country === null || !country ? university : `${university}, ${country}`}
        </Typography>
      </Box>
    </Box>
  )
}
export default EducationCard
